const IconCheckInLuggageUnavailable = props => (
	<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1.41418 29.4142L29.4142 1.41418L30.8142 2.81421L25.1811 8.44731C25.2796 8.72483 25.3333 9.02311 25.3333 9.33332V25.3333C25.3333 26.8 24.1333 28 22.6667 28C22.6667 28.7333 22.0667 29.3333 21.3333 29.3333C20.6 29.3333 20 28.7333 20 28H12C12 28.7333 11.4 29.3333 10.6667 29.3333C9.93332 29.3333 9.33332 28.7333 9.33332 28C8.33466 28 7.45962 27.4436 7.00288 26.6255L2.81421 30.8142L1.41418 29.4142ZM21.1707 12.4578L19.3333 14.2951V23C19.3333 23.5467 19.7867 24 20.3333 24C20.88 24 21.3333 23.5467 21.3333 23V13C21.3333 12.8011 21.2733 12.6146 21.1707 12.4578ZM17 16.6284L15 18.6284V23C15 23.5467 15.4533 24 16 24C16.5467 24 17 23.5467 17 23V16.6284ZM12.6667 23V20.9618L10.6667 22.9618V23C10.6667 23.5467 11.12 24 11.6667 24C12.2133 24 12.6667 23.5467 12.6667 23Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.66666 21.3333V9.33332C6.66666 7.86666 7.86666 6.66666 9.33332 6.66666H12V3.99999C12 3.26666 12.6 2.66666 13.3333 2.66666H18.6667C19.4 2.66666 20 3.26666 20 3.99999V6.66666H21.3333L16 12C15.4533 12 15 12.4533 15 13L12.6667 15.3333V13C12.6667 12.4533 12.2133 12 11.6667 12C11.12 12 10.6667 12.4533 10.6667 13V17.3333L6.66666 21.3333ZM18 6.66666H14V4.66666H18V6.66666Z"
			fill="currentColor"
		/>
	</svg>
);

export default IconCheckInLuggageUnavailable;
